module.exports = __webpack_public_path__ + "img/complete_03.ac81d7f1.png";